export default __webpack_public_path__ + "static/media/Headshot-2.6d119275.png";